export default __webpack_public_path__ + "static/media/Pagina-Inicial.4a3f3a84.svg";